// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { RequestState, RowNew } from '../../../../components/Table/types';
import { flattenBurns } from '../../../../utils/flattenBurns';
import { useCustomSort } from '../../../../utils/sortByCreatedAt';
import { useGetBurnQueries } from './useGetBurnQueries';

export const useGetBurnRows = () => {
  const burnQueries = useGetBurnQueries();

  const queryDataMap = [
    { query: burnQueries.burnRequests2Step, state: RequestState.Requested, isThreeStep: false },
    { query: burnQueries.executedBurns2Step, state: RequestState.Executed, isThreeStep: false },
    { query: burnQueries.rejectedBurns2Step, state: RequestState.Rejected, isThreeStep: false },
    { query: burnQueries.rejectedBurns3Step, state: RequestState.Rejected, isThreeStep: true },
    { query: burnQueries.failedBurns3Step, state: RequestState.Failed, isThreeStep: true },
    { query: burnQueries.executedBurns3Step, state: RequestState.Executed, isThreeStep: true },
    { query: burnQueries.burnRequests3Step, state: RequestState.Rejected, isThreeStep: true },
  ];

  const isLoading = queryDataMap.some(({ query }) => query.isLoading);

  const rows = queryDataMap.reduce((acc: RowNew[], { query, state, isThreeStep }) => {
    const dataArray = query.data || [];

    const newRows = flattenBurns(dataArray, state, isThreeStep);

    return acc.concat(newRows);
  }, []);
  const sortedByCreateTime = useCustomSort(rows);
  return {
    isLoading,
    rows: sortedByCreateTime,
  };
};
